import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=b9b6ee2c"
var script = {}
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=b9b6ee2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports